import { useForm } from '@/common/form/FormContext';
import { DropdownSelect } from '@/common/form/formFields/DropdownSelect';
import { useEffect, useMemo } from 'react';

const toOption = ({ value, displayName }) => ({ value, displayName });

const withAll = (displayName, options) => [{ value: null, displayName }, ...options.map(toOption)];

export const TestDashboardFilters = ({ suites }) => {
  const { formValues, assignValue } = useForm();
  const { suiteCode, testCode, rqmtCode } = formValues;

  const tests = useMemo(
    () => suites.filter((suite) => suiteCode == null || suite.value === suiteCode).flatMap((suite) => suite.tests),
    [suites, suiteCode],
  );

  const rqmts = useMemo(
    () => tests.filter((test) => testCode == null || test.value === testCode).flatMap((test) => test.requirements),
    [tests, testCode],
  );

  // Clear child selections that fall outside the newly selected parent
  useEffect(() => {
    if (testCode != null && !tests.some((test) => test.value === testCode)) assignValue('testCode', null);
  }, [tests, testCode]);

  useEffect(() => {
    if (rqmtCode != null && !rqmts.some((rqmt) => rqmt.value === rqmtCode)) assignValue('rqmtCode', null);
  }, [rqmts, rqmtCode]);

  const suiteOptions = useMemo(() => withAll('All Suites', suites), [suites]);
  const testOptions = useMemo(() => withAll('All Tests', tests), [tests]);
  const rqmtOptions = useMemo(() => withAll('All Requirements', rqmts), [rqmts]);

  return (
    <>
      <DropdownSelect fieldDef={{ field: 'suiteCode', displayName: 'Test Suite', values: suiteOptions }} />
      <DropdownSelect fieldDef={{ field: 'testCode', displayName: 'Test', values: testOptions }} />
      <DropdownSelect fieldDef={{ field: 'rqmtCode', displayName: 'Requirement', values: rqmtOptions }} />
    </>
  );
};
